import {BrowseNavigator} from '$lib/classes/services/browse-navigator';

export const prerender = false
export const ssr = false

export async function load({parent}) {
    const {
        displayWords,
        currentWord,
        filterSettings,
    } = await parent();

    const browseNavigator = new BrowseNavigator(filterSettings, displayWords, currentWord);

    return {
        browseNavigator: browseNavigator,
    }
}